// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './ProductDetailsColumn.module.scss';;


type Props = {
  children: React.Node,
  className?: string,
}

const ProductDetailsColumn = ({ children, className }: Props) => (
  <div className={classNames(styles.root, className)}>
    {children}
  </div>
);

export default ProductDetailsColumn;
